import React from 'react'
import { Router } from 'routes/Router'

export const App = () => {
  return <Router />
}
